import React from 'react';
import { Icon, IconProps } from '@chakra-ui/react';

export const QRScanIcon: React.FC<IconProps> = props => {
  return (
    <Icon boxSize={6} {...props}>
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M3 7V5a2 2 0 0 1 2-2h2M21 7V5a2 2 0 0 0-2-2h-2M3 17v2a2 2 0 0 0 2 2h2M21 17v2a2 2 0 0 1-2 2h-2" />
        <rect x="7" y="7" width="10" height="10" rx="1" />
      </svg>
    </Icon>
  );
};

export const QRDisplayIcon: React.FC<IconProps> = props => {
  return (
    <Icon boxSize={6} {...props}>
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <rect x="4" y="4" width="16" height="16" rx="2" strokeWidth="1.5" />
        <rect x="7.5" y="7.5" width="3" height="3" rx="0.5" strokeWidth="1.5" />
        <rect x="13.5" y="7.5" width="3" height="3" rx="0.5" strokeWidth="1.5" />
        <rect x="7.5" y="13.5" width="3" height="3" rx="0.5" strokeWidth="1.5" />
      </svg>
    </Icon>
  );
};
